module.exports = __webpack_public_path__ + "img/diamond-3.39b6a7f6.png";